import { render } from "./SelectIncongruity.vue?vue&type=template&id=24a02b8e"
import script from "./SelectIncongruity.vue?vue&type=script&lang=js"
export * from "./SelectIncongruity.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__